import mainStyle from "../mainStyle.module.scss";

import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

const ParentMenu = ({ target, label, openParent, handleParentClick, lightIcon, icon }) => {
  const theme = useTheme();

  return (
    <Box
      className={mainStyle["anchorItem"]}
      style={{
        backgroundColor: openParent === target ? theme.palette.primary.main : "",
        cursor: "pointer",
      }}
      onClick={() => handleParentClick(target)}
    >
      <img
        src={openParent === target ? lightIcon : icon}
        alt="wired"
        style={{ width: "40px" }}
      />
      <span
        className={mainStyle["anchorItem_text"]}
        style={{
          color:
            openParent === "profiles"
              ? theme.palette.primary.white
              : theme.palette.primary.main,
        }}
      >
        {label}
      </span>
    </Box>);
};

export default ParentMenu;